import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
// import SuperTagHelper from "@/components/functionals/SuperTagHelperDashBoard.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import formatterTask from "@/components/functionals/formatterTask.vue";

export default [
  {
    prop: "Id",
    label: "# Objetivo",
    width: 100,
    sortable: true
  },
  {
    prop: "Name",
    label: "Nombre de Objetivo",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "ResponsibleImage"
    }
  },
  {
    prop: "DateInit",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "DateEnd",
    label: "Fecha Compromiso",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  /*
      {
        prop: "Duration",
        label: "Duracción",
        width: 110,
        sortable: true,
        formatter: row => row.DateEnd - row.DateInit
      },
      */
  {
    prop: "PerpectiveID",
    label: "Tipo Perspectiva",
    width: 200,
    sortable: true,
    formatter: formatterTask
  },
  {
    prop: "CreatorName",
    label: "Creador",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "CreatorImage"
    }
  },
  {
    prop: "SupervisorName",
    label: "Supervisor",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "SupervisorImage"
    }
  },
  {
    prop: "TypeStrategic",
    label: "Tipo",
    width: 200,
    sortable: true,
    formatter: formatterTask
  }
];
